export default __webpack_public_path__ + "static/media/33.9b099f31.png";